import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const NotFound = () => {
    const navigate = useNavigate();
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, [])

    return (
        <>
            {window.location.pathname === '/' ? (
                <div class='bgdmg d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                    <div>
                        <br />
                        <br /><br />
                        <div class='col-sm-4 col-7 m-auto position-relative'>
                            <img style={{ position: 'absolute', top: '0', left: '0', width: '100%' }} data-aos="fade-down" src={require('../image/may.png')} alt="" />
                            <img style={{ width: '100%' }} src={require('../image/i.png')} data-aos="zoom-in" alt="" />
                            <img style={{ position: 'absolute', top: '0', left: '0', width: '100%' }} data-aos="fade-up" src={require('../image/services.png')} alt="" />

                        </div>
                        <button className='btn btn-light rounded-5' onClick={() => navigate('/')}>
                            Go to Home page
                            <span><i className="bi bi-arrow-right"></i></span>
                        </button>
                    </div>
                </div>
            )
                :
                (

                    <div className='d-flex col-11 m-auto align-items-center justify-content-center' style={{ height: '100vh' }}>
                        <div className='col-lg-6 col-md-8 col-11 m-auto'>
                            <div className='col-sm-11 m-auto'>
                                <div>
                                    <img src={require('../image/404.webp')} alt="404 Not Found" width='100%' />
                                </div>
                            </div>
                            <div>
                                <button className='btn btn-dark rounded-5' onClick={() => navigate('/')}>
                                    Go to Home page
                                    <span><i className="bi bi-arrow-right"></i></span>
                                </button>

                            </div>
                        </div>
                    </div>
                )
            }

        </>
    );
};

export default NotFound;
